export class Group {
  id: number;
  name: string;
  description: string;
  restrictedMember: number;
  mission: string;
  accessibility: number;
  accessibilityName: string;
  requestWorkflow: boolean;
  requestQuestion: string;
  invitationWorkflow: boolean;
  pictureUrl: string;
  filter: string;
  autoAssign: boolean;
  autoRemove: boolean;
  autoUpdate: boolean;
  canLeave: boolean;
  capacity: number;
  promotionGroupId: number | null;
  promotionGroupName: string;
  displayMembers: boolean;
  communicationLevel: number;
  hasPicture: boolean;
  hideLeaders: boolean;
  flagged: boolean;
  createdby: string;
}

export class AddMembers {
  groupId: number;
  user: string;
  memberList: number[];
  isLeader: boolean;
}

export class AddMemberRequest {
  groupId: number;
  user: string;
  memberId: number;
  answer: string;
}

export class RemoveMembers {
  groupId: number;
  memberList: number[];
}
